import {useEffect, useMemo, useState} from 'react'
import {Column} from 'react-table'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useCentral} from '../../../../../../hooks/useCentral'
import {useKhipu} from '../../../../../../hooks/useKhipu'
import {TabCentralModel} from '../../../../../../models'
import {SelectOption} from '../../../../../../models/utility.model'
import {useCentralServices} from '../../../../../hoteleria/hooks/useCentralServices'
import {getFactConfig} from '../../../../services/configFacturation.service'
import {ConfigFacturationColumnModel} from '../../../../model/configFacturation.model'

const TableConfigFacturation = () => {
  const {
    data,
    setData,
    setPagination,
    loading,
    setLoading,
    pagination,
    clearSelected,
    updateTable,
    setUpdateTable,
    selectedOn,
    clearTable,
    setClearTable,
  } = useKTable()
  const {searchValues, clearSearchValues} = useKhipu()
  const {changeCurrentTabItem, currentTabItem, isAllowed} = useCentral()
  const [client, setClient] = useState<SelectOption[]>([])
  const [site, setSites] = useState<SelectOption[]>([])
  const {getClients, getSites} = useCentralServices()

  const getClientsFn = async () => {
    const data = await getClients({isCombo: true}, 1)
    setClient(data)
  }

  const getSitesFn = async () => {
    const data = await getSites({isCombo: true}, 1)
    setSites(data)
  }

  useEffect(() => {
    getClientsFn()
    getSitesFn()
    return () => {
      clearSearchValues()
    }
  }, [])

  const getConfigFacturationList = async () => {
    try {
      setLoading(true)
      const {data: response} = await getFactConfig(searchValues, pagination.currentPage)
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleShowDetail = (item: ConfigFacturationColumnModel) => {
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: true,
      content: {
        ...currentTabItem.content,
        detailPanel: 'form-config-facturation',
      },
      idToDelete: '',
      idToEdit: item.Id as any,
      objectInfo: item,
    }
    changeCurrentTabItem(obj)
    clearSelected()
  }

  const handleGetId = (id: any) => {
    let idChange = id === currentTabItem.idToDelete ? '' : id
    const obj: TabCentralModel = {
      ...currentTabItem,
      showPanel: false,
      idToDelete: idChange,
      idToEdit: '',
    }
    changeCurrentTabItem(obj)
  }

  useEffect(() => {
    if (clearTable) {
      if (pagination.currentPage === 1) {
        getConfigFacturationList()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setClearTable(false)
    }
  }, [clearTable])

  useEffect(() => {
    if (updateTable) {
      if (pagination.currentPage === 1) {
        getConfigFacturationList()
      } else {
        setPagination({
          ...pagination,
          currentPage: 1,
          perPage: 10,
          totalResults: 0,
        })
      }
      setUpdateTable(false)
    }
  }, [updateTable])

  useEffect(() => {
    getConfigFacturationList()
    clearSelected()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    if (currentTabItem.loadingTable) {
      getConfigFacturationList()
      clearSelected()
      changeCurrentTabItem({...currentTabItem, loadingTable: false})
    }
  }, [currentTabItem.loadingTable])

  const columns: Column<ConfigFacturationColumnModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} />,
        id: 'selection',
        Cell: ({...props}) => (
          <KTableSelectionCellNonMultiple
            id={props.data[props.row.index].Id}
            clickHandler={() => handleGetId(props.row.original.Id)}
          />
        ),
      },

      {
        Header: (props) => (
          <KTableHeader
            tableProps={props}
            title='Cliente'
            name={'ClienteId'}
            selecteable
            data={client}
          />
        ),
        accessor: 'ClienteNombre',
      },
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Site' name={'SiteId'} selecteable data={site} />
        ),
        accessor: 'SiteNombre',
      },

      {
        Header: (props) => (
          <KTableHeader tableProps={props} title='Día Inicio' searcheable number />
        ),
        accessor: 'ValorInicio',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Día Fin' searcheable number />,
        accessor: 'ValorFin',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions_ver',
        Cell: ({...props}) =>
          isAllowed('VER') ? (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleShowDetail(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          ) : (
            <></>
          ),
      },
    ],
    [selectedOn, client, site],
  )

  return (
    <KTCard shadow className='m-5'>
      <KTable data={data} columns={columns as any} />
      {loading ? <KTableLoading title='Cargando...' /> : null}
    </KTCard>
  )
}

const TableConfigFacturationWrapper = () => {
  return (
    <KTableProvider>
      <TableConfigFacturation />
    </KTableProvider>
  )
}

export {TableConfigFacturationWrapper}
